'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('@emotion/react');

/* Here are emotion utils re-exported to be distributed as a part of Nexus*/
/**
 * React hook which provides theme object from React.Context. This hook works with Nexus theme.
 * It has the same functionality as `useTheme` from emotion, but direct import from emotion will not work.
 * @see https://storybook.olxtech.pl/?path=/docs/docs-themes-and-tokens-how-to-use--page#usetheme
 */
var useTheme = react.useTheme;
/**
 * Emotion utility which converts string css to css objects.
 * @example
 * render(
 *   <div
 *     css={css`
 *       background-color: hotpink;
 *       &:hover {
 *         color: pink;
 *       }
 *     `}
 *   >
 *     This has a pink background.
 *   </div>
 * )
 * @see https://emotion.sh/docs/css-prop#string-styles
 */
var css = react.css;
/**
 * Emotion utility takes in a css keyframe definition and returns an object you can use in styles.
 * You can use strings or objects just like css.
 * @example
 * const bounce = keyframes`
 *   from, 10% to {
 *     transform: translate3d(0,0,0);
 *   }
 *   90% {
 *     transform: translate3d(0,-4px,0);
 *   }
 * `
 * render(
 *   <div
 *     css={css`
 *       animation: ${bounce} 1s ease infinite;
 *     `}
 *   >
 *     some bouncing text!
 *   </div>
 * )
 * @see https://emotion.sh/docs/keyframes
 */
var keyframes = react.keyframes;
/**
 * Emotion component creates global styles in document
 * @example
 * <Global
 *       styles={css`
 *         body {
 *           color: hotpink;
 *         }
 *       `}
 *     />
 * @see https://emotion.sh/docs/globals
 */
var Global = react.Global;

exports.Global = Global;
exports.css = css;
exports.keyframes = keyframes;
exports.useTheme = useTheme;
//# sourceMappingURL=emotionUtils.js.map
